import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: 'companies',
  title: 'Empresas',
  endpoint: '/app/company',
}
